import { TYPES } from "./default_wallet.type";

const initState = {
  defaultWalletAll: null,
};

const defaultWalletReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_WALLET_ALL:
      return {
        ...state,
        defaultWalletAll: payload,
      };

    default:
      return state;
  }
};

export default defaultWalletReducer;
